import { render } from "./QuestionnaireEdit.html?vue&type=template&id=dd6e9edc&scoped=true&ts=true"
import script from "./QuestionnaireEdit.ts?vue&type=script&lang=ts"
export * from "./QuestionnaireEdit.ts?vue&type=script&lang=ts"

import "./QuestionnaireEdit.css?vue&type=style&index=0&id=dd6e9edc&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6e9edc"]])

export default __exports__